import { Form, Button, Alert } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import { setIsLoading } from '../general/actions';
import AlertModal from '../general/alertModal';
import { useParams, useNavigate } from 'react-router-dom';

function ResetPassword(props) {
    const navigate = useNavigate();
    const { token } = useParams();
    const { setIsLoading, isCreatigUser } = props;

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('warning');
    const [show, setShow] = useState(props.show);
    const [showPassword, setShowPassword] = useState(false);

    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertModalOnClose, setAlertModalOnClose] = useState();

    const setPasswordInParent = (password) => {
        if (!token) props.passwordConfirmed(password);
        else setShow(true);
    };

    useEffect(() => { setShow(props.show); }, [props.show]);

    useEffect(() => {
        if (isCreatigUser) props.setMessage(message);
    }, [message, isCreatigUser]);

    useEffect(() => {
        setPasswordInParent('');
        if (newPassword !== confirmPassword) {
            setMessageType('warning');
            setMessage('Las contraseñas no coinciden');
        } else if (!newPassword || !isPasswordValid(newPassword)) {
            setMessageType('warning');
            setMessage('Mínimo 8 caracteres incluyendo al menos un número');
        } else {
            setPasswordInParent(newPassword);
            setMessage('');
        }
    }, [newPassword, confirmPassword]);

    function isPasswordValid(value) {
        return /^(?=.*\d).{8,}$/.test(value);
    }

    const clearForm = () => { setNewPassword(''); setConfirmPassword(''); };

    const updatePassword = async (e) => {
        e.preventDefault();
        if (token) return updatePasswordUsingToken(e);
        setIsLoading(true);
        try {
            const response = await axiosInstance.put('/users/password', { newPassword, confirmPassword });
            clearForm();
            setAlertModalShow(true);
            setAlertModalMsg(response.data.message);
        } catch (error) {
            setAlertModalShow(true);
            setAlertModalMsg(error?.response?.data?.message || 'No pudimos completar la operación. Intenta de nuevo.');
        } finally {
            setIsLoading(false);
        }
    };

    const updatePasswordUsingToken = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await axiosInstance.put('password/reset/' + token, { newPassword, confirmPassword });
            clearForm();
            setAlertModalShow(true);
            setAlertModalMsg(response.data.message);
            setAlertModalOnClose(() => () => { navigate('/login'); });
        } catch (error) {
            setAlertModalShow(true);
            setAlertModalMsg(error?.response?.data?.message || 'No pudimos completar la operación. Intenta de nuevo.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="order-section">
                <div className="order-section-header">
                    <i className="fa fa-lock" /> {isCreatigUser ? 'Crear contraseña' : 'Cambiar contraseña'}
                </div>
                <div className="order-section-body">
                    <Form onSubmit={updatePassword}>
                        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 4 }}>
                            <div style={{ flex: 1, minWidth: 200 }}>
                                <Form.Label className="report-field-label">Nueva contraseña</Form.Label>
                                <div className="auth-input-wrap">
                                    <i className="fa fa-lock auth-input-icon" />
                                    <Form.Control
                                        type={showPassword ? 'text' : 'password'}
                                        value={newPassword}
                                        placeholder="••••••••"
                                        style={{ paddingRight: 38 }}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                    <button type="button" className="auth-input-toggle" onClick={() => setShowPassword(v => !v)} tabIndex={-1}>
                                        <i className={showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'} />
                                    </button>
                                </div>
                            </div>
                            <div style={{ flex: 1, minWidth: 200 }}>
                                <Form.Label className="report-field-label">Repetir contraseña</Form.Label>
                                <div className="auth-input-wrap">
                                    <i className="fa fa-lock auth-input-icon" />
                                    <Form.Control
                                        type={showPassword ? 'text' : 'password'}
                                        value={confirmPassword}
                                        placeholder="••••••••"
                                        style={{ paddingRight: 38 }}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 10, marginBottom: 2 }}>
                            {[
                                { ok: newPassword.length >= 8,   label: 'Mínimo 8 caracteres' },
                                { ok: /\d/.test(newPassword),    label: 'Al menos un número' },
                                { ok: newPassword.length > 0 && newPassword === confirmPassword, label: 'Las contraseñas coinciden' },
                            ].map(({ ok, label }) => (
                                <span key={label} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12, color: newPassword.length === 0 ? 'var(--abi-muted)' : ok ? '#166534' : '#991b1b', fontWeight: 500 }}>
                                    <i className={`fa ${newPassword.length === 0 ? 'fa-circle-o' : ok ? 'fa-check-circle' : 'fa-times-circle'}`} style={{ fontSize: 13 }} />
                                    {label}
                                </span>
                            ))}
                        </div>

                        {message && !isCreatigUser && (
                            <Alert variant={messageType} className="py-2 mt-2" style={{ fontSize: 13 }}>
                                <i className="fa fa-info-circle" /> {message}
                            </Alert>
                        )}

                        {show && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12 }}>
                                <Button variant="primary" type="submit" disabled={!!message} size="sm">
                                    <i className={isCreatigUser ? 'fa fa-check' : 'fa fa-save'} />
                                    {' '}{isCreatigUser ? 'Confirmar contraseña' : 'Cambiar contraseña'}
                                </Button>
                            </div>
                        )}
                    </Form>
                </div>
            </div>

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                onClose={alertModalOnClose} setOnClose={setAlertModalOnClose}
            />
        </>
    );
}

function mapStateToProps(state) {
    return { isLoading: state.isLoading };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
